import React from 'react'
import './intro.css';
import Me from './../../image/man.png';
import Scroll from '../../image/scrolling.png'

function Intro() {
  return (
    <div className="i">
      <div className="i-left">
        <div className="i-left-wrapper">
          <h2 className="i-intro">Hello, My name is </h2>
          <h2 className="i-name">Ahmed Elsayed</h2>
          <div className="i-title">

            <div className="i-title-wrapper">
              <div className="i-title-item">Software Eng</div>
              <div className="i-title-item">Web Developer</div>
              <div className="i-title-item">Front-end Eng</div>
              <div className="i-title-item">Back-end Eng</div>
              <div className="i-title-item">Full stack devloper</div>
            </div>

          </div>

          <p className="i-desc">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit.
            Doloremque corrupti a harum, magni nesciunt esse dolorum ex illo, quos omnis repellendus
            at corporis recusandae repellat animi quibusdam veritatis architecto velit.
          </p>
        </div>
        <img src={Scroll} alt="" className="i-scroll" />
      </div>
      <div className="i-right">
        <div className="i-bg"></div>
        <img src={Me} alt="Ahmed Elsayed" className="i-img" />
      </div>
    </div>
  )
}

export default Intro
